import { useIntl } from 'react-intl';
import { Account, Schedule } from '@/features/accounts/types';
import ScheduleIdentity from '@/features/accounts/schedule/components/ScheduleIdentity';

interface ScheduleSummaryProps {
  schedule: Schedule | null;
  isLoading: boolean;
  error: Error | null;
}

function ScheduleSummary({ schedule, isLoading, error }: ScheduleSummaryProps) {
  const intl = useIntl();

  if (isLoading) {
    return (
      <div className="flex flex-col gap-1">
        <div className="h-4 w-40 animate-pulse rounded bg-slate-200" />
        <div className="h-3 w-20 animate-pulse rounded bg-slate-200" />
      </div>
    );
  }
  if (error) {
    return (
      <span className="text-xs text-red-500">
        {intl.formatMessage({ id: 'common.error' })}
      </span>
    );
  }
  if (!schedule) {
    return (
      <span className="text-xs text-slate-400 italic">
        {intl.formatMessage({ id: 'schedule.list.empty' })}
      </span>
    );
  }

  return <ScheduleIdentity schedule={schedule} />;
}

interface Props {
  account: Account;
  schedule?: Schedule | null;
  isLoading?: boolean;
  error?: Error | null;
}

export default function AccountCell({
  account,
  schedule = null,
  isLoading = false,
  error = null,
}: Props) {
  return (
    <div className="flex flex-col">
      <span className="text-sm font-medium text-slate-700 truncate max-w-[200px]" title={account.email}>
        {account.email}
      </span>
      <ScheduleSummary schedule={schedule} isLoading={isLoading} error={error} />
    </div>
  );
}
